




































// vue
import {Vue, Component, Emit} from 'vue-property-decorator';

@Component({
  components: {
  },
})
export default class App extends Vue {
  public content: string = '';
  public name: string = '';
  public tel: string = '';

  @Emit('submit')
  public submit() {
    return {
      name: this.name,
      tel: this.tel,
      content: this.content,
    };
  }
}
